import { Injectable } from '@angular/core';
import { BaseService } from '../alcance/services/_base.service';
import { Capacitor } from '@capacitor/core';
import { ResponsavelDBService } from '../database/responsavel-db.service';

@Injectable({
  providedIn: 'root'
})
export class ResponsavelService extends BaseService{
    override classname: string = 'ResponsavelService';
    public override route: string = 'responsavel';
    public override database = Capacitor.isNativePlatform() ? new ResponsavelDBService() : new ResponsavelDBService();
}
